module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1"
    }
  }, [_vm._v("1. Before the Coming of the Rails")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter2"
    }
  }, [_vm._v("2. The Railroad Geography of Rhode Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Boston Gets Ready for the Railroad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Railroad Comes to Providence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. South County Joins the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Other Survivor: The Providence and Worcester Railroad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Go West, Young Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The East Bay Makes Tracks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Little Guys")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Juice Lines: Rhode Island Gets Wired")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Struggle for Kingston Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Railroads of Rhode Island Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0